import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import CuurentRound from "../../hooks/DataFetchers/round.js";
import Timer from "../../hooks/DataFetchers/time.js";
import CuurentRoundl from "../../hooks/DataFetchers/roundl.js";
import Timerl from "../../hooks/DataFetchers/timel.js";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import { API_URL_3, Api_Url } from "../../utils/ApiUrl.js";
import {
  Api_Url_Leia_Claims,
  API_URL_2,
  Api_Url_Rain,
  Api_Url_Staging,
} from "../../utils/ApiUrl.js";

import useSignatureLeiaClaims from "../../hooks/userSignLeiaClaims";
import Loader from "../../hooks/loader.js";
import { toast } from "react-toastify";
import { setupNetwork } from "../../utils/wallet.js";
import { method } from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";

const AllProjectsPremium = ({ role }) => {
  const [Allprojectssss, setAllprojectssss] = useState([]);
  const { account, chainId } = useWeb3React();
  // const account = "0x9799C5820A3bB7f97a1099432C9cFdF164fd50F7";

  const { userSignLeiaClaims } = useSignatureLeiaClaims();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [error, seterror] = useState("");
  const [user, setUser] = useState(false);
  const [msg, setMsg] = useState("");

  const getAllProjectsData = async () => {
    if (role !== "premium") return;

    setAllprojectssss([]);

    try {
      const premiumConfig = {
        method: "get",
        url: `${Api_Url}/users/premium/buyer-listing?by=${account.toLowerCase()}&limit=20&offset=1`,
      };

      const creditConfig = {
        method: "get",
        url: `${Api_Url}/credit/buyer-listing?by=${account.toLowerCase()}&limit=10&offset=1`,
      };

      const minerConfig = {
        method: "get",
        url: `${Api_Url}/nodeminer/${account.toLowerCase()}/transactions`,
      };

      const [premiumRes, creditRes, minerRes] = await Promise.all([
        axios(premiumConfig),
        axios(creditConfig),
        axios(minerConfig),
      ]);

      const premiumData = premiumRes?.data?.data?.buyerParticipation || [];
      const creditData = creditRes?.data?.data?.buyerParticipation || [];
      const minerData = minerRes?.data?.data || [];

      const combined = [...premiumData, ...creditData];

      // Group and merge duplicates by 'privateSale' or '_id' or 'projectName'
      const merged = combined.reduce((acc, curr) => {
        const key = curr.privateSale || curr.projectName || curr._id;

        if (!key) return acc;

        if (!acc[key]) {
          acc[key] = { ...curr }; // First instance
        } else {
          // Sum numeric fields
          acc[key].totalPurchases =
            (acc[key].totalPurchases || 0) + (curr.totalPurchases || 0);
          acc[key].totalSaleConverted =
            (acc[key].totalSaleConverted || 0) + (curr.totalSaleConverted || 0);
          acc[key].dopPurchased =
            (acc[key].dopPurchased || 0) + (curr.dopPurchased || 0);
          acc[key].totalMatchainPurchased =
            (acc[key].totalMatchainPurchased || 0) +
            (curr.totalMatchainPurchased || 0);
        }

        return acc;
      }, {});

      // Convert merged object back to array
      const finalArray = Object.values(merged);

      // Miner reward logic
      const totalMinerReward = minerData?.totalMinerReward || 0;

      if (totalMinerReward > 0) {
        const rainIndex = finalArray.findIndex((p) => p._id === "RAIN");

        if (rainIndex !== -1) {
          // Add reward to existing RAIN project
          finalArray[rainIndex].dopPurchased =
            (finalArray[rainIndex].dopPurchased || 0) + totalMinerReward;
        } else {
          // Push new RAIN project
          finalArray.push({
            _id: "RAIN",
            totalPurchases: null,
            dopPurchased: totalMinerReward,
            bundlePurchased: null,
            quantityPurchased: null,
            totalMatchainPurchased: null,
            privateSale: "RAIN",
            projectName: null,
            projectImage: null,
            totalSaleConverted: null,
          });
        }
      }

      setAllprojectssss(finalArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (role && account) {
      if (role === "premium") {
        getAllProjectsData();
      }
    }

  }, [role, account]);

  useEffect(() => {
    localStorage.removeItem("dopToken")
  }, [])

  const getUserSign = async (project) => {
    if (account) {
      // console.log("chainIdchainIdchainIdchainId", chainId);
      // if (chainId == 1 || chainId === 11155111 || chainId === 56) {
      // console.log("chain id")
      signInUser(project);

      // getIsClaimAvailable();
      // } else {
      // toast.error("Please Switch to Ethereum Mainnet from your wallet");
      // chainSwitch();
      // }
    }
  };

  // useEffect(() => {
  //   if (chainId !== 1) {
  //     chainSwitch();
  //   }
  // }, [chainId]);

  // const chainSwitch = async () => {
  //   // console.log("change chain called");
  //   let b = await setupNetwork(1);
  // };

  const signInUser = async (project) => {
    console.log(
      "innnnnnn",
      project,
      project?.privateSale === "LUCKIFY",
      API_URL_3
    );
    localStorage.setItem("project", project?.privateSale);

    let devicee = localStorage.getItem("device");
    if (devicee === "Safe{Wallet}") {
      console.log(devicee, "deviceedeviceedevicee");
      // if (chainId === 1) {
      let tok = localStorage.getItem("dopToken");
      let addrSign = localStorage.getItem("addrSign");
      if (tok && addrSign === account) {
        // CHANGE HERE
        if (project?.privateSale === "RAIN") {
          window.location.assign("/claim-detail");
        } else if (project?.privateSale === "LUCKIFY") {
          history.push("/claims-luckify")
        } else {
          window.location.assign("/claimschedule");
        }
      } else {
        setLoader(true);
        setMsg("Please check your wallet for signature");
        let url = API_URL_2;
        // CHANGE HERE
        if (project?.privateSale === "RAIN") {
          url = Api_Url_Rain;
        } else if (project?.privateSale === "LUCKIFY") {
          url = API_URL_3;
        }
        try {
          let v = await userSignLeiaClaims();
          setMsg("");
          var config = {
            method: "post",
            url: `${url}/auth/signin/safe`,
            data: {
              walletAddress: account.toLowerCase(),
              sign: v,
            },
          };
          await axios(config)
            .then(function (res) {
              const resData = res?.data?.data;
              console.log(resData, "resData sigin");
              localStorage?.setItem("dopToken", resData?.accessToken);
              localStorage?.setItem("refreshToken", resData?.refreshToken);
              localStorage?.setItem("addrSign", account);
              localStorage?.setItem("signValue", v);
              // CHANGE HERE
              if (project?.privateSale === "RAIN") {
                window.location.assign("/claim-detail");
              } else if (project?.privateSale === "LUCKIFY") {
                history.push("/claims-luckify")
              } else {
                window.location.assign("/claimschedule");
              }
              // window.location.reload()
            })
            .catch(function (err) {
              if (err?.response?.data?.statusCode === 403) {
                seterror(err.response.data.message);
              } else {
                seterror(
                  "This wallet is not eligible for any LEIA token claims."
                );
              }

              // console.log("error here",err.response.data.message)

              setUser(true);
              setLoader(false);
              throw err;
            });
        } catch (err) {
          setLoader(false);
        }
      }
      // }
    } else {
      console.log(devicee, " esle deviceedeviceedevicee");
      // if (chainId === 1) {
      let tok = localStorage.getItem("dopToken");
      console.log(tok, " esle dop token");

      let addrSign = localStorage.getItem("addrSign");
      console.log(addrSign, " esle address token");

      if (tok && addrSign.toLowerCase() === account.toLowerCase()) {
        console.log("if further");

        // CHANGE HERE
        if (project?.privateSale === "RAIN") {
          window.location.assign("/claim-detail");
        } else if (project?.privateSale === "LUCKIFY") {
          history.push("/claims-luckify")
        } else {
          window.location.assign("/claimschedule");
        }
      } else {
        console.log("else further");

        setLoader(true);
        setMsg("Please check your wallet for signature");
        try {
          let v = await userSignLeiaClaims();
          let url = API_URL_2;
          // CHANGE HERE
          if (project?.privateSale === "RAIN") {
            url = Api_Url_Rain;
          } else if (project?.privateSale === "LUCKIFY") {
            url = API_URL_3;
          }
          setMsg("");
          var config = {
            method: "post",
            url: `${url}/auth/signin`,
            data: {
              walletAddress: account.toLowerCase(),
              sign: v,
            },
          };
          await axios(config)
            .then(function (res) {
              const resData = res?.data?.data;
              console.log(resData, "resData sigin");
              localStorage?.setItem("dopToken", resData?.accessToken);
              localStorage?.setItem("refreshToken", resData?.refreshToken);
              localStorage?.setItem("addrSign", account);
              localStorage?.setItem("signValue", v);
              localStorage.setItem("project", project?.privateSale);
              // CHANGE HERE
              if (project?.privateSale === "RAIN") {
                window.location.assign("/claim-detail");
              } else if (project?.privateSale === "LUCKIFY") {
                history.push("/claims-luckify")
              } else {
                window.location.assign("/claimschedule");
              }
              // window.location.reload()
            })
            .catch(function (err) {
              if (err?.response?.data?.statusCode === 403) {
                seterror(err.response.data.message);
              } else {
                seterror(
                  "This wallet is not eligible for any LEIA token claims."
                );
              }
              setUser(true);
              setLoader(false);
              throw err;
            });
        } catch (err) {
          // const connectorId = window.localStorage.getItem("connectorId");
          // await logout(connectorId);
          // localStorage.removeItem("connectorId");
          // localStorage.removeItem("flag");
          console.log(err);

          setLoader(false);
        }
      }
      // }
    }
  };

  console.log(Allprojectssss, "Allprojectssss");

  // unlock time in UTC
  const rainUnlockTime = new Date(Date.UTC(2025, 8, 9, 12, 0, 0)); // September 9, 2025, 12:00 PM UTC

  const [isRainUnlocked, setIsRainUnlocked] = useState(false);

  useEffect(() => {
    let interval;

    const checkUnlock = () => {
      const nowUtc = new Date();

      if (nowUtc >= rainUnlockTime) {
        setIsRainUnlocked(true);
        clearInterval(interval); // stop checking once unlocked
      }
    };

    checkUnlock();
    interval = setInterval(checkUnlock, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {loader && (
        <Loader text={"Please sign the transaction from your wallet"} />
      )}
      <div className="custom-table">
        <div class="table-responsive">
          <table className="table m-0">
            <thead>
              <tr>
                <th>Project Name</th>
                <th className="text-center">Total Purchases</th>
                <th className="text-center">Amount Spent</th>
                <th className="text-center">Amount Purchased</th>
                <th className="text-center">Claim Type</th>
                <th className="text-center">Claim Status</th>
                <th className="text-center">Action</th>
                <th className="text-center">Claim Action</th>
              </tr>
            </thead>
            <tbody>
              {Allprojectssss?.map((project, index) => (
                <tr key={project._id || index}>
                  <td>
                    <div className="twice-items">
                      {project?.projectImage ? (
                        <img
                          src={project.projectImage}
                          // src={`/assets/presaletokens/${project?.privateSale?.toLowerCase()}.png`}
                          alt={`${project.projectName || project?.privateSale
                            } Logo`}
                          className="img-fluid"
                        />
                      ) : (
                        <img
                          // src={project.projectImage}
                          src={`https://media-gems.gems.vip/logos/${project?.privateSale.toLowerCase()}.svg`}
                          alt={`${project.projectName || project?.privateSale
                            } Logo`}
                          className="img-fluid"
                        />
                      )}

                      <h6>{project.projectName || project?.privateSale}</h6>
                    </div>
                  </td>
                  <td className="text-center">{project.totalPurchases}</td>
                  <td className="text-center">
                    {project?.totalSaleConverted
                      ? `$${project?.totalSaleConverted?.toLocaleString()}`
                      : ""}
                  </td>
                  <td className="text-center">
                    {project?.privateSale != "MATCHAIN"
                      ? project?.dopPurchased?.toLocaleString()
                      : project?.totalMatchainPurchased?.toLocaleString()}{" "}
                    {project?.privateSale}
                  </td>
                  {project?.privateSale == "LEIA" ||
                    project?.privateSale === "LUCKIFY" ? (
                    <td className="text-center">Vesting</td>
                  ) : project?.privateSale === "RAIN" ? (
                    <td className="text-center">Non-linear vesting</td>
                  ) : (
                    <td className="text-center">Immediate</td>
                  )}

                  {project?.privateSale === "LEIA" ||
                    project?.privateSale === "LUCKIFY" ? (
                    <td className="text-center available">Available</td>
                  ) : project?.privateSale === "RAIN" ? (
                    isRainUnlocked ? (
                      <td className="text-center available">Available</td>
                    ) : (
                      <td className="text-center available">
                        {/* Sep 9, 12PM UTC */}
                        Not Available
                      </td>
                    )
                  ) : (
                    <td className="text-center unavailable">Not Available</td>
                  )}

                  <td className="text-center">
                    <Link to={`/allpurchasespremium/${project?._id}`}>
                      All Purchases
                    </Link>
                  </td>
                  <td className="text-center">
                    <button
                      disabled={
                        (project?.privateSale != "LEIA" &&
                          project?.privateSale != "LUCKIFY" &&
                          project?.privateSale != "RAIN") ||
                        (project?.privateSale === "RAIN" && !isRainUnlocked)
                      }
                      className={
                        project?.privateSale == "LEIA" ||
                          project?.privateSale == "LUCKIFY" ||
                          (project?.privateSale === "RAIN" && isRainUnlocked)
                          ? "btn-claim"
                          : "btn-claim-disabled"
                      }
                      onClick={() => {
                        getUserSign(project);
                      }}
                    >
                      Claim
                    </button>
                    {/* </Link> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* <div className="custom-pagination">
          <p>SHOWING 1-10 OF 145</p>
          <ul class="pagination">
            <li class="page-item">
              <a class="page-link" href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <g opacity="0.5">
                    <path
                      d="M7.88904 1.93555L5.38763 1.93555L1.99459 7.99682L4.496 7.99682L7.88904 1.93555Z"
                      fill="#939FA3"
                    />
                    <path
                      d="M7.88904 14.0703L5.38763 14.0703L1.99459 8.00904L3.57108 6.96117L4.496 8.00904L7.88904 14.0703Z"
                      fill="#939FA3"
                    />
                    <path
                      d="M8.01655 6.85742H14.9616L13.6869 9.14313H6.74182L8.01655 6.85742Z"
                      fill="#939FA3"
                    />
                  </g>
                </svg>
              </a>
            </li>
            <li class="page-item">
              <a class="page-link active" href="#">
                1
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                2
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                3
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                4
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                5
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M9.11108 1.93555L11.6125 1.93555L15.0055 7.99682L12.5041 7.99682L9.11108 1.93555Z"
                    fill="#30F1B6"
                  />
                  <path
                    d="M9.11108 14.0703L11.6125 14.0703L15.0055 8.00904L13.429 6.96117L12.5041 8.00904L9.11108 14.0703Z"
                    fill="#30F1B6"
                  />
                  <path
                    d="M3.31318 6.85742H10.2582L8.98351 9.14313H2.03845L3.31318 6.85742Z"
                    fill="#30F1B6"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div> */}
      </div>
    </>
  );
};

export default AllProjectsPremium;
